import PropTypes from "prop-types";
import React from "react";

/* Builds a select input for referential data of the form:
    [
        {
            code: "code1",
            translations: {
                en: "English Translation",
                fr: "French Translation",
                // other languages...
            }
        },
        ...
    ]
    or
    [
        {
            id: 132,
            translations: {
                en: "English Translation",
                fr: "French Translation",
                // other languages...
            }
        },
        ...
    ]
 */

export default function ReferentialSelect(
    {
        name,
        firstOption,
        elementId,
        selectedItem,
        handleChange,
        referential,
        displayLanguage,
        className = '',
        style = {},
    } ) {

    return (
        <select
            id={ elementId }
            name={ name }
            className={ className || `form-select select-input` }
            value={ selectedItem || "" }
            onChange={ handleChange }
            style={ style }
        >
            <option value="">{ firstOption }</option>
            { referential.map(
                ( item, index ) => {
                    let key = index;
                    let value = null;

                    if (item.code && typeof item.code === 'string') {
                        key = item.code + index;
                        value = item.code
                    } else if (item.id && typeof item.id === 'number') {
                        key = item.id;
                        value = item.id;
                    }
                    return <option
                        value={ value }
                        key={ key }
                    >{ item.translations?.[ displayLanguage ] }</option>;
                } ) }
        </select>
    );
};

ReferentialSelect.propTypes = {
    name: PropTypes.string,
    firstOption: PropTypes.string,
    elementId: PropTypes.string,
    selectedItem: PropTypes.string | PropTypes.number,
    handleChange: PropTypes.func.isRequired,
    referential: PropTypes.array.isRequired,
    displayLanguage: PropTypes.string.isRequired,
    className: PropTypes.string,
    style: PropTypes.object,
}
